<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">LGT Client Links</b-navbar-brand>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-row>
			<b-col></b-col>
			<b-col></b-col>
			<b-col class="col-md-8">
				<b-row>
					<b-col>
						<h4>Add new Client Link</h4>
						<p>Before you use this function, make sure you have seen and verified proof that the customer is entitled to access and view the requested LGT client's data.</p>
						<p>LGT Wealth will be sent an email requesting them to make the link and include the data for the requested client and all associated accounts in the daily data feed.</p>
							<b-row>
								<div class="col-md-6">
									LGT Client Number: <b-form-input class="mb-2" v-model="clientLink.clientNumber"></b-form-input>
								</div>
								<div class="col-md-6">
									Money Guided Customer ID: <b-form-input class="mb-2" v-model="clientLink.customerId"></b-form-input>
								</div>
							</b-row>
							<b-row class="mt-3">
								<b-col>
									<b-button variant="success" @click="makeLink">Request Link</b-button>
								</b-col>
							</b-row>
					</b-col>
				</b-row>
			</b-col>
			<b-col></b-col>
			<b-col></b-col>
		</b-row>

	</div>
</div>
</template>
<script>
export default {
  name: 'ClientLinks',
  data() {
	return{
		customers: null,
		clientLink: {customerId: null, clientNumber: null}
	}
  },
  methods: {
	list: function(){
		this.getCustomers();
	},
	onLoad() {
		this.list();
	},
	makeLink : function() {
		this.$http.post(this.$config.ApiUri + "/Lgt/ClientLinks", this.clientLink)
			.then((result) => {
				alert("The link between " + result.data.clientNumber + " and " + result.data.customerID + " has been made.");
				this.clientLink.customerId = "";
				this.clientLink.clientNumber = "";
			}
		)
	},
	getCustomers(){
		this.$http.get(this.$config.ApiUri + "/Customers")
			.then((result) => {
				this.customers = result.data;
			}
		)
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style scoped="true">
	.child-cat {
		margin:3px;
		background-color: rgb(104, 84, 150);
	}
	.parent-cat {
		margin:3px;
		background-color: rgb(53, 43, 77);
	}

</style>